import React from 'react';
import { useRef, useState } from 'react';
import { AppTextField, AppTextareaField } from '../../../../../../Components/FormKit';

const cardHeader = (title) => (
    <div style={{
        background: '#f8fafc',
        padding: '0.65rem 1rem',
        borderBottom: '1px solid #e2e8f0',
        borderRadius: '14px 14px 0 0',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
    }}>
        <span style={{ fontWeight: 700, fontSize: '0.72rem', color: '#1565C0', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>
            {title}
        </span>
        <div style={{ flex: 1, height: '1px', background: '#bfdbfe' }} />
    </div>
);

export const StepUserEmail = ({
    email,
    setEmail,
    ccEmails,
    addCcEmail,
    updateCcEmail,
    removeCcEmail,
    currentStatus,
    emailSubject,
    setEmailSubject,
    emailContent,
    setEmailContent,
    adminComment,
    setAdminComment,
    stepData,
    setUploadedFiles,
    isReadOnly,
    errors = {},
    resolvedStatus
}) => {
    const inputRef = useRef(null);
    const [files, setFiles] = useState([]);

    const handleFileSelect = (e) => {
        const added = Array.from(e.target.files || []);
        const updated = [...files, ...added];
        setFiles(updated);
        setUploadedFiles(updated);
        e.target.value = '';
    };

    const removeFile = (index) => {
        const updated = files.filter((_, i) => i !== index);
        setFiles(updated);
        setUploadedFiles(updated);
    };

    return (
        <div className="fk-root flex flex-column gap-3">

            {/* Card 1: Destinatario */}
            <div className="tk-table-card">
                {cardHeader('Destinatario y Copias — Usuario')}
                <div style={{ padding: '1rem' }} className="flex flex-column gap-3">
                    <AppTextField
                        label="Correo del destinatario"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="correo@ejemplo.com"
                        disabled={isReadOnly}
                        invalid={!!errors.email}
                        errorMessage="Campo requerido"
                    />

                    {/* CC */}
                    <div className="flex flex-column gap-2">
                        <div className="flex align-items-center justify-content-between">
                            <span className="fk-label" style={{ margin: 0 }}>CC — Con Copia</span>
                            {!isReadOnly && (
                                <button
                                    type="button"
                                    onClick={addCcEmail}
                                    className="fk-btn fk-btn--secondary fk-btn--sm"
                                    style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}
                                >
                                    <i className="pi pi-plus" style={{ fontSize: '0.7rem' }} />
                                    Agregar CC
                                </button>
                            )}
                        </div>
                        {ccEmails.map((ccEmail, index) => (
                            <div key={index} className="flex gap-2 align-items-center">
                                <div className="fk-input flex-1">
                                    <input
                                        className="p-inputtext"
                                        value={ccEmail}
                                        onChange={(e) => updateCcEmail(index, e.target.value)}
                                        placeholder="destinatario@ejemplo.com"
                                        disabled={isReadOnly}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                {!isReadOnly && (
                                    <button
                                        type="button"
                                        className="fk-icon-btn fk-icon-btn--danger"
                                        onClick={() => removeCcEmail(index)}
                                        title="Eliminar"
                                    >
                                        <i className="pi pi-times" style={{ fontSize: '0.8rem' }} />
                                    </button>
                                )}
                            </div>
                        ))}
                        {ccEmails.length === 0 && (
                            <span style={{ fontSize: '0.78rem', color: '#94a3b8', fontStyle: 'italic' }}>
                                Sin destinatarios en copia
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* Card 2: Correo */}
            {currentStatus !== 'pending' && (
                <div className="tk-table-card">
                    {cardHeader('Configuración del Correo')}
                    <div style={{ padding: '1rem' }} className="flex flex-column gap-3">
                        <AppTextField
                            label="Asunto"
                            value={emailSubject}
                            onChange={(e) => setEmailSubject(e.target.value)}
                            placeholder="Asunto del correo"
                            disabled={isReadOnly}
                            invalid={!!errors.emailSubject}
                            errorMessage="Campo requerido"
                        />
                        <AppTextareaField
                            label="Contenido del correo"
                            value={emailContent}
                            onChange={(e) => setEmailContent(e.target.value)}
                            rows={8}
                            placeholder="Escribe el mensaje aquí..."
                            readOnly={isReadOnly}
                            invalid={!!errors.emailContent}
                            errorMessage="Campo requerido"
                        />
                    </div>
                </div>
            )}

            {/* Card 3: Comentario interno + adjuntos */}
            <div className="tk-table-card">
                {cardHeader('Notas y Adjuntos')}
                <div style={{ padding: '1rem' }} className="flex flex-column gap-3">
                    <AppTextField
                        label="Comentarios Internos (Admin — opcional)"
                        value={adminComment}
                        onChange={(e) => setAdminComment(e.target.value)}
                        placeholder="Notas solo visibles para administradores..."
                        disabled={isReadOnly}
                    />

                </div>
            </div>

            {/* Documentos: adjuntar nuevos + historial en una sola card */}
            {((!isReadOnly && ['scheduled', 'postponed', 'completed', 'paused', 'unsuccessful'].includes(resolvedStatus || currentStatus)) || (stepData?.files && stepData.files.length > 0)) && (
                <div className="tk-table-card">
                    {cardHeader('Documentos')}
                    <div style={{ padding: '1rem' }} className="flex flex-column gap-3">

                        {/* Adjuntar nuevos */}
                        {!isReadOnly && ['scheduled', 'postponed', 'completed', 'paused', 'unsuccessful'].includes(resolvedStatus || currentStatus) && (
                            <div className="flex align-items-center gap-2 flex-wrap">
                                <button
                                    type="button"
                                    className="fk-btn fk-btn--secondary fk-btn--sm"
                                    onClick={() => inputRef.current?.click()}
                                    style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', flexShrink: 0 }}
                                >
                                    <i className="pi pi-paperclip" style={{ fontSize: '0.72rem' }} />
                                    Adjuntar documentos
                                </button>
                                <input ref={inputRef} type="file" multiple accept=".xml,.pdf,image/*" style={{ display: 'none' }} onChange={handleFileSelect} />
                                {files.length === 0 && (
                                    <span style={{ fontSize: '0.75rem', color: '#94a3b8', fontStyle: 'italic' }}>Sin archivos adjuntos</span>
                                )}
                                {files.map((file, i) => (
                                    <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: '99px', padding: '0.2rem 0.4rem 0.2rem 0.65rem', fontSize: '0.73rem', color: '#334155', maxWidth: '200px' }}>
                                        <i className="pi pi-file" style={{ fontSize: '0.68rem', flexShrink: 0 }} />
                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{file.name}</span>
                                        <button type="button" onClick={() => removeFile(i)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', padding: '0 0.1rem', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                            <i className="pi pi-times" style={{ fontSize: '0.62rem' }} />
                                        </button>
                                    </span>
                                ))}
                            </div>
                        )}

                        {/* Historial */}
                        {stepData?.files && stepData.files.length > 0 && (
                            <>
                                {!isReadOnly && ['scheduled', 'postponed', 'completed', 'paused', 'unsuccessful'].includes(resolvedStatus || currentStatus) && (
                                    <div style={{ height: '1px', background: '#e2e8f0' }} />
                                )}
                                {['scheduled', 'postponed', 'completed', 'paused', 'unsuccessful'].map(status => {
                                    const histFiles = stepData.files.filter(f => f.file_type === `ocular_visit_${status}`);
                                    if (histFiles.length === 0) return null;
                                    const label = { scheduled: 'Programada', postponed: 'Reprogramada', paused: 'Pausada', completed: 'Completado', unsuccessful: 'No exitosa' }[status];
                                    return (
                                        <div key={status}>
                                            <h4 style={{ margin: '0 0 0.5rem', fontSize: '0.72rem', fontWeight: 700, color: status === 'unsuccessful' ? '#b91c1c' : '#475569', borderBottom: '1px solid #e2e8f0', paddingBottom: '0.25rem' }}>
                                                {status === 'unsuccessful' && <i className="pi pi-times-circle mr-1" />}
                                                {label}
                                            </h4>
                                            <div className="flex flex-wrap gap-2">
                                                {histFiles.map(file => (
                                                    <div key={file.id} className="flex align-items-center gap-2 p-2 border-1 border-gray-300 border-round bg-white shadow-1" style={{ minWidth: '200px' }}>
                                                        <i className={`pi ${file.file_name?.endsWith('.pdf') ? 'pi-file-pdf text-red-500' : 'pi-image text-blue-500'} text-xl`} />
                                                        <div className="flex flex-column" style={{ maxWidth: '160px' }}>
                                                            <span className="text-sm font-medium text-gray-800 white-space-nowrap overflow-hidden text-overflow-ellipsis" title={file.file_name}>{file.file_name}</span>
                                                            <span className="text-xs text-gray-500">{new Date(file.created_at).toLocaleDateString()}</span>
                                                        </div>
                                                        {file.s3_url && (
                                                            <a href={file.s3_url} target="_blank" rel="noopener noreferrer" className="ml-auto flex align-items-center p-1 hover:bg-gray-100 border-round">
                                                                <i className="pi pi-eye text-blue-600 cursor-pointer" />
                                                            </a>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                </div>
            )}

        </div>
    );
};
